import React from 'react';
import FormBase from 'components/FormBase';
import './LoginForm.css';

export default function LoginForm(prop) {
    const login_scene_path = process.env.PUBLIC_URL + '/img/login_scene.png';
    const login_human1_path = process.env.PUBLIC_URL + '/img/login_scene_human1.png';
    const login_human2_path = process.env.PUBLIC_URL + '/img/login_scene_human2.png';

    return (
        <FormBase title={prop.title} >
            <div className={'loginFormScene'}>
                <img src={login_scene_path} alt={'login scene'} width={'100%'} height={'100%'} />
            </div>
            <div className={'loginFormScene_human1'}>
                <img src={login_human1_path} alt={'login scene'} width={'100%'} height={'100%'} />
            </div>
            <div className={'loginFormScene_human2'}>
                <img src={login_human2_path} alt={'login scene'} width={'100%'} height={'100%'} />
            </div>
            <div className={'loginFormContent'} >
                {prop.children}
            </div>
        </FormBase>
    )
}
